import React from "react";
import { Link } from "react-router-dom";
import { profile, marquee } from "../../data/site";
import { useTypewriter } from "../../lib/hooks";
import { ArrowRight, Download, SOCIAL_ICONS } from "../../lib/icons";
import Terminal from "./Terminal";

const Hero = ({ onToggleTheme }) => {
  const typed = useTypewriter(profile.roles);

  return (
    <section className="hero" id="top">
      <div className="hero__inner">
        <div className="hero__copy">
          <p className="hero__status">
            <i aria-hidden="true" />
            Currently building at {profile.current} · {profile.location}
          </p>

          <h1 className="hero__name">
            <span>Ouri</span>
            <span>Alkada</span>
          </h1>

          <p className="hero__roles" aria-live="polite">
            <b>{typed}</b>
            <i className="caret" aria-hidden="true" />
          </p>

          <p className="hero__lede">{profile.tagline}</p>

          <div className="hero__actions">
            <Link className="btn btn--primary" to="/projects">
              See the work <ArrowRight size={17} />
            </Link>
            <a className="btn btn--ghost" href={profile.resume} target="_blank" rel="noopener noreferrer">
              <Download size={17} /> Résumé
            </a>
            <Link className="btn btn--ghost" to="/contact">
              Get in touch
            </Link>
          </div>

          <ul className="socials">
            {profile.socials.map((social) => {
              const Icon = SOCIAL_ICONS[social.icon];
              return (
                <li key={social.label}>
                  <a
                    className="icon-btn"
                    href={social.url}
                    target={social.url.startsWith("http") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    aria-label={social.label}
                  >
                    <Icon size={18} />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="hero__panel">
          <Terminal onToggleTheme={onToggleTheme} />
        </div>
      </div>

      <span className="hero__scroll" aria-hidden="true">
        <i />
        Scroll
      </span>
    </section>
  );
};

export const Marquee = () => (
  <div className="marquee" aria-hidden="true">
    {/* Rendered twice so the -50% translate loops without a seam. */}
    <div className="marquee__track">
      {[0, 1].map((half) =>
        marquee.map((item) => (
          <span key={`${half}-${item}`} className="marquee__item">
            {item}
          </span>
        ))
      )}
    </div>
  </div>
);

export default Hero;
